import { ranking } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';

const rankStyle = (rank: number) => {
  if (rank === 1) {
    return 'bg-accent-500 text-accent-950';
  }
  if (rank === 2) {
    return 'bg-primary-500 text-background-50';
  }
  if (rank === 3) {
    return 'bg-secondary-500 text-background-50';
  }
  return 'bg-background-200 text-foreground-600';
};

const trendIcon = (trend: string) => {
  if (trend === 'up') {
    return <i className="ri-arrow-up-line text-primary-600"></i>;
  }
  if (trend === 'down') {
    return <i className="ri-arrow-down-line text-secondary-500"></i>;
  }
  return <i className="ri-subtract-line text-foreground-400"></i>;
};

const maxHeat = Math.max(...ranking.map((item) => item.heat));

export default function RankingBoard() {
  return (
    <section id="ranking" className="bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-6 md:py-16 lg:px-10">
        <SectionHeading
          kicker="黑料大全"
          title="黑料大全热度榜"
          desc="按近七日浏览与讨论量综合排序，每天零点刷新一次，看看哪条存档被翻出来最多。"
          accent="primary"
          action={{ label: '完整榜单', href: '#ranking' }}
        />

        <Reveal>
          <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <div className="hidden grid-cols-12 gap-4 border-b border-background-200 bg-background-200/70 px-5 py-3 text-xs font-medium tracking-wider text-foreground-600 md:grid">
              <span className="col-span-1">排名</span>
              <span className="col-span-6">存档条目</span>
              <span className="col-span-2">分类</span>
              <span className="col-span-3">热度走势</span>
            </div>
            {ranking.map((item) => (
              <a
                key={item.rank}
                href="#compilation"
                className="grid cursor-pointer grid-cols-1 items-center gap-3 border-b border-background-200 px-4 py-4 transition-colors last:border-0 hover:bg-primary-50/50 md:grid-cols-12 md:gap-4 md:px-5"
              >
                <div className="flex items-center gap-3 md:col-span-1">
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${rankStyle(item.rank)}`}
                  >
                    {item.rank}
                  </span>
                  <span className="font-heading text-base font-bold text-foreground-900 md:hidden">
                    {item.title}
                  </span>
                </div>
                <div className="hidden md:col-span-6 md:block">
                  <h3 className="truncate font-heading text-base font-bold text-foreground-900 transition-colors hover:text-primary-700">
                    {item.title}
                  </h3>
                </div>
                <div className="md:col-span-2">
                  <span className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                    {item.category}
                  </span>
                </div>
                <div className="flex items-center gap-3 md:col-span-3">
                  <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-300">
                    <div
                      className="h-full rounded-full bg-primary-500"
                      style={{ width: `${(item.heat / maxHeat) * 100}%` }}
                    ></div>
                  </div>
                  <span className="flex shrink-0 items-center gap-1 text-xs text-foreground-600">
                    {trendIcon(item.trend)}
                    {item.heat}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}